import { createListenerMiddleware } from '@reduxjs/toolkit';

import { ALL_CLASSES } from 'src/constants/classes.constants';
import { saveLastSelectedTeacherClassId } from 'src/services/class-picker.service';
import { AppStartListening } from 'src/store';
import { setSelectedClass } from 'src/store/features';

export const selectedTeacherClassListener = createListenerMiddleware();

const startListeningSelectedTeacherClass =
  selectedTeacherClassListener.startListening as AppStartListening;

startListeningSelectedTeacherClass({
  actionCreator: setSelectedClass,
  effect: (action) => {
    const classId =
      action.payload && action.payload.length > 1
        ? ALL_CLASSES
        : action.payload?.[0].sourcedId;

    if (classId) {
      saveLastSelectedTeacherClassId(classId);
    }
  },
});
